import React from 'react';
import { CreditBalanceWidget } from '@/types/platform';
import './CreditBalance.css';

interface CreditBalanceProps {
  widget: CreditBalanceWidget;
  credits: number | null;
  getTranslation: (key: string) => string;
}

const CreditBalance: React.FC<CreditBalanceProps> = ({ widget, credits, getTranslation }) => {
  if (!widget.visible) return null;

  return (
    <div className="credit-balance">
      <span className="credit-balance-label">{getTranslation(widget.labelKey)}</span>
      <span className="credit-balance-value">
        {credits !== null ? credits : '—'}
      </span>
    </div>
  );
};

export default CreditBalance;
